module.exports = __webpack_public_path__ + "img/report-2.1299108c.jpg";